import { useSelector } from 'react-redux';

import { faComputer } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Typography } from '@mui/material';

import DrawerBody from './DrawerBody';
import DrawerFooter from './DrawerFooter';
import { DrawerComponentProps } from './DrawerManager';
import { selectCurrentUser } from 'src/store/configSlice';

function ComputerDevicePhoneVerificationDrawer(props: DrawerComponentProps) {
    const { onClose, onNext } = props;
    const { phoneNumber } = useSelector(selectCurrentUser);

    return (
        <>
            <DrawerBody sx={{ alignItems: 'center', gap: 2, width: '100%' }}>
                <FontAwesomeIcon icon={faComputer} size="2x" />
                <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
                    Using computer
                </Typography>
                <Typography variant="body1">
                    Browser notifications are off. {phoneNumber ? 'Verify your' : 'Add a'} phone
                    number so we can send you alerts.
                </Typography>
            </DrawerBody>
            <DrawerFooter sx={{ gap: 1.5, width: '100%' }}>
                <Button
                    fullWidth
                    disableElevation
                    color="primary"
                    variant="contained"
                    onClick={onNext}
                >
                    {!phoneNumber ? 'Add phone number' : 'Verify phone number'}
                </Button>
                <Button fullWidth variant="text" onClick={onClose}>
                    Go back
                </Button>
            </DrawerFooter>
        </>
    );
}

export default ComputerDevicePhoneVerificationDrawer;
